import { handleActions } from 'redux-actions';

import {
  FETCH_MANAGE_USER,
  FETCH_USER_BY_ID,
  FETCH_USER_PERMISSIONS_BY_ID,
  GET_SECTOR_ROLE,
} from '../constants/index';

const initialState = {
  users: {},
  userDataById: {},
  userPermissions: [],
  getSectorAndRole: [],
};

export const manageUsers = handleActions(
  {
    [FETCH_MANAGE_USER]: (state = initialState, action = {}) => ({
      ...state,
      users: action.payload,
    }),
    [FETCH_USER_BY_ID]: (state = initialState, action = {}) => ({
      ...state,
      userDataById: action.payload,
    }),
    [FETCH_USER_PERMISSIONS_BY_ID]: (state = initialState, action = {}) => ({
      ...state,
      userPermissions: action.payload,
    }),
    [GET_SECTOR_ROLE]: (state = initialState, action = {}) => ({
      ...state,
      getSectorAndRole: action.payload,
    }),
  },
  initialState,
);
